import { Close, FullScreen as FullScreenIcon, OffScreen } from '@icon-park/react'
import type { ModalProps as AntdModalProps } from 'antd/lib/modal'
import cn from 'classnames'
import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Modal as AntdModal } from 'antd'
import { isArray } from 'lodash'

import './index.less'

export type ModalProps = AntdModalProps & {
  children?: React.ReactNode
  hasFooter?: boolean
  config?: {
    fullScreen?: boolean
    width?: string | number
    height?: string | number
    logo?: React.ReactNode
  }
}

export const Modal = ({
  visible,
  className,
  title,
  width,
  style = {},
  children,
  onCancel,
  hasFooter = true,
  footer,
  config = {
    width: 'auto',
    height: 'auto',
  },
  ...rest
}: ModalProps) => {
  const [fullscreen, setFullscreen] = useState<boolean>(false)
  const supportFullscreen = config.fullScreen

  useEffect(() => {
    return () => {
      setFullscreen(false)
    }
  }, [visible])

  const Title = ({
    title,
    logo,
    fullscreen,
    onToggleFullscreen,
    onClose,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any) => {
    return (
      <Fragment>
        <div className="ant-modal-header-title">
          {logo && logo}
          <span>{title}</span>
        </div>
        <div className="ant-modal-header-actions">
          <a className="modal-fullscreen-wrap" onClick={onToggleFullscreen}>
            {fullscreen ? <OffScreen /> : <FullScreenIcon />}
          </a>
          <a className="modal-close-wrap" onClick={onClose}>
            <Close theme="outline" />
          </a>
        </div>
      </Fragment>
    )
  }

  const computeWidth = supportFullscreen
    ? fullscreen
      ? '100vw'
      : width || config.width
    : width || config.width

  const computeHeight = supportFullscreen ? (fullscreen ? '100vh' : config.height) : 'inherit'

  style.height = computeHeight
  if (supportFullscreen && fullscreen) {
    style.top = 0
  } else {
    delete style.top
  }

  const footerConfig = hasFooter
    ? (isArray(footer) ? footer.length > 0 : footer)
      ? footer
      : undefined
    : null

  return (
    <AntdModal
      visible={visible}
      title={
        supportFullscreen ? (
          <Title
            logo={config.logo}
            title={title}
            fullscreen={fullscreen}
            supportFullscreen={supportFullscreen}
            onClose={onCancel}
            onToggleFullscreen={() => {
              setFullscreen(!fullscreen)
              if (!fullscreen) {
              }
            }}
          />
        ) : (
          title
        )
      }
      onCancel={onCancel}
      centered={supportFullscreen ? true : rest.centered ? true : false}
      width={computeWidth}
      style={style}
      className={cn([
        {
          'support-fullscreen': supportFullscreen,
          fullscreen: fullscreen,
          'no-header': supportFullscreen && !(config.logo || title),
        },
        className,
      ])}
      footer={footer}
      {...rest}
    >
      {children}
    </AntdModal>
  )
}

export default Modal
